import React from 'react'
import styles from './navbar.module.scss'

function Navbar() {
    return (
        <header className={styles.header}>
            <div className={styles.wrapper}>
                <div className={styles.logo}>
                    <span>
                    <img src="https://www.gov.uk/assets/collections/govuk_publishing_components/crests/org_crest_18px-5863abda23ccb562f7ca4599038901db5a7f03eb277df5d86d51491033492b62.png" alt="UKHSA" />
                        <br></br>UK Health<br></br>Security<br></br>Agency
                    </span>
                </div>
                <div className={styles.headerText}>
                    Terraform Private Registry Information Point
                </div>
            </div>
        </header>
    )
}

export default Navbar
